import logo from "../assets/newlogo.png";
import { 
  FaFacebookF, 
  FaTwitter, 
  FaLinkedinIn, 
  FaInstagram, 
  FaYoutube,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaPaperPlane
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-black text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          
          {/* Column 1 - Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              {/* <div className="w-12 h-12 rounded-xl bg-gradient-to-r from-blue-600 to-purple-600 flex items-center justify-center shadow-lg shadow-blue-600/20">
                <span className="text-white font-bold text-xl">A</span>
              </div>
              <div className="text-2xl font-bold bg-gradient-to-r from-blue-400 to-blue-400 bg-clip-text text-transparent">
                AxionNest
              </div> */}
               <div className="flex items-center gap-4 w-full max-w-[80%]">
                      <div className="cursor-pointer">
                        <img
                          src={logo}
                          className="w-full h-20  object-contain"
                          alt="Logo"
                          // onClick={(e) => {
                          //   onLogoClick?.(e);
                          //   const token = localStorage.getItem("access_token");
                          //   navigate(token ? "/home" : "/");
                          // }}
                        />
                      </div>
                    </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Empowering researchers and educators with next-generation AI tools and integrated solutions.
            </p>
            
            {/* Social Icons - Colored on hover */}
            {/* <div className="flex gap-3">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-all duration-300 hover:scale-110">
                <FaFacebookF className="text-gray-300 hover:text-white" size={18} />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-400 transition-all duration-300 hover:scale-110">
                <FaTwitter className="text-gray-300 hover:text-white" size={18} />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-pink-600 transition-all duration-300 hover:scale-110">
                <FaInstagram className="text-gray-300 hover:text-white" size={18} />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-700 transition-all duration-300 hover:scale-110">
                <FaLinkedinIn className="text-gray-300 hover:text-white" size={18} />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-red-600 transition-all duration-300 hover:scale-110">
                <FaYoutube className="text-gray-300 hover:text-white" size={18} />
              </a>
            </div> */}
          </div>

          {/* Column 2 - Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-white relative inline-block">
              Quick Links
              {/* <span className="absolute -bottom-2 left-0 w-12 h-0.5 bg-gradient-to-r from-blue-500 to-purple-500"></span> */}
            </h3>
            <ul className="space-y-4">
              {[ "About Us","Contact Us", "Blogs", "Careers"].map((item, i) => {
                let href = "#";
                if (item === "Contact Us") href = "/contact";
                else if (item === "About") href = "/about";
                else if (item === "Blogs") href = "/blogs";
                else if (item === "Careers") href = "/careers";
                return (
                  <li key={i}>
                    <a href={href} className="text-gray-400 hover:text-white hover:translate-x-2 inline-block transition-all duration-300">
                      {item}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>

          {/* Column 3 - Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-white relative inline-block">
              Contact Us
              {/* <span className="absolute -bottom-2 left-0 w-12 h-0.5 bg-gradient-to-r from-blue-500 to-purple-500"></span> */}
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-8 h-8 bg-gray-800 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                  <FaMapMarkerAlt className="text-blue-400" size={16} />
                </div>
                <span className="text-gray-400 text-sm">in5 Tech, Dubai Internet City, Dubai, United Arab Emirates</span>
              </li>
              <li className="flex items-center gap-3 group">
                <div className="w-8 h-8 bg-gray-800 rounded-lg flex items-center justify-center group-hover:bg-blue-600 transition-colors">
                  <FaEnvelope className="text-blue-400 group-hover:text-white" size={16} />
                </div>
                <a href="mailto:support@axionnest.com" className="text-gray-400 hover:text-white transition-colors text-sm">
                  support@axionnest.com
                </a>
              </li>
              {/* <li className="flex items-center gap-3 group">
                <div className="w-8 h-8 bg-gray-800 rounded-lg flex items-center justify-center group-hover:bg-green-600 transition-colors">
                  <FaPhone className="text-green-400 group-hover:text-white" size={16} />
                </div>
                <a href="tel:+1234567890" className="text-gray-400 hover:text-white transition-colors text-sm">
                  +1 (234) 567-890
                </a>
              </li>
              <li className="flex items-center gap-3 group">
                <div className="w-8 h-8 bg-gray-800 rounded-lg flex items-center justify-center group-hover:bg-purple-600 transition-colors">
                  <FaPhone className="text-purple-400 group-hover:text-white" size={16} />
                </div>
                <a href="tel:+1987654321" className="text-gray-400 hover:text-white transition-colors text-sm">
                  +1 (987) 654-321
                </a>
              </li> */}
            </ul>
          </div>

          {/* Column 4 - Newsletter */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-white relative inline-block">
              Newsletter
              {/* <span className="absolute -bottom-2 left-0 w-12 h-0.5 bg-gradient-to-r from-blue-500 to-purple-500"></span> */}
            </h3>
            <p className="text-gray-400 text-sm mb-4">
              Subscribe to get updates on new features and offers.
            </p>
            <div className="relative">
              <input 
                type="email" 
                placeholder="Your email address"
                className="w-full bg-gray-800 text-white text-sm rounded-lg pl-4 pr-12 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 border border-gray-700"
              />
              <button className="absolute right-1 top-1 bg-[#2E5DA8] hover:from-blue-700 hover:to-purple-700 text-white rounded-lg px-4 py-2 text-sm font-medium transition-all duration-300 flex items-center gap-2">
                Subscribe <FaPaperPlane size={12} />
              </button>
            </div>
            <p className="text-gray-500 text-xs mt-3">
              We respect your privacy. Unsubscribe anytime.
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm order-2 md:order-1">
  © {new Date().getFullYear()} AxionNest. All rights reserved. Built with ❤️ for researchers
</p>

            <div className="flex gap-6 order-1 md:order-2">
              <a href="/privacy" className="text-gray-500 hover:text-white text-sm transition-colors">Privacy Policy</a>
              <a href="/terms" className="text-gray-500 hover:text-white text-sm transition-colors">Terms of Service</a>
              <a href="/help" className="text-gray-500 hover:text-white text-sm transition-colors">Help Center</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;